import React from "react";
import { useSelector } from "react-redux";
import { getObjectByKey } from "../../../utils/utils";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import crbWidgetImg from "../../../../assests/crb/crbWidget.png";

const CrbCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const { platforms } = useSelector(state => state.uiData);
    const crb = getObjectByKey("crb", platforms);

    return (
        <WidgetCarouselCard
            color="#35A0B8"
            titleColor="#FFF"
            title={texts.crb}
            image={crbWidgetImg}
            imageAlt={texts.crb}
            link={crb?.link}
        />
    );
};

export default CrbCarouselWidget;
